import { useMemo } from 'react'
import { useFetchSecuritiesByTags } from '@/trading/tradingQueries'

export function useStocksSearchModel(positiveTags: string[], negativeTags: string[], enabled = true) {
    const { data: securitiesByTag, refetch, isLoading } = useFetchSecuritiesByTags(positiveTags, enabled)

    const items = useMemo(() => {
        return (
            securitiesByTag?.filter(
                (security: any) =>
                    !negativeTags.some((tag) => security.ethicalTags.some((et: any) => et.tag === tag)) &&
                    security.securityDetails &&
                    security.securityDetails.priceInfo &&
                    !isNaN(security.changeInPriceYTD),
            ) || []
        )
    }, [securitiesByTag, negativeTags])

    return { items, isLoading, refetch }
}

export default useStocksSearchModel
